/**
 * Sam's Club does not publish unit counts: a club's pickup quantity is 1
 * ("low stock", isLowInStock) or 8 ("plenty"). pkg/samsclub stores exactly
 * those, so show the level instead of a misleading "1 left" / "8 left".
 */
export const SAMSCLUB_STOCK_CAP = 8;

/** Label for a Sam's Club stock level, or null for other retailers / no stock. */
export function samsClubStockLabel(
  retailer: string | undefined,
  count: number,
  labels: { inStock: string; lowStock: string },
): string | null {
  if (retailer !== "samsclub" || count <= 0) return null;
  return count >= SAMSCLUB_STOCK_CAP ? labels.inStock : labels.lowStock;
}
